import * as type from './constants';

let state = {
  layoutType: 'vertical',
  layoutWidth: 'fluid',
  leftSideBarTheme: 'light',
  leftSideBarType: 'default',
  topbarTheme: 'light',
  showRightSidebar: false,
  isMobile: false,
  showSidebar: true,
  leftMenu: false,
  userName: null,
  masterData: {},
  loading: false,
  listUser: [],
  countSubmitCases: 0,
  KYCStatus: [],
  fcrmStatus: [],
  ruleCDLov: [],
  lovProcess: {},
  logoImage: {
    showLogoImage: false,
    largeLogoImage: '',
  },
};

const globalReducers = (arg, action) => {
  switch (action.type) {
    case type.CHANGE_LAYOUT:
      state = {
        ...state,
        layoutType: action.payload,
      };
      break;
    case type.CHANGE_LAYOUT_WIDTH:
      state = {
        ...state,
        layoutWidth: action.payload,
      };
      break;
    case type.CHANGE_SIDEBAR_THEME:
      state = {
        ...state,
        leftSideBarTheme: action.payload,
      };
      break;
    case type.CHANGE_SIDEBAR_TYPE:
      state = {
        ...state,
        leftSideBarType: action.payload.sidebarType,
      };
      break;
    case type.CHANGE_TOPBAR_THEME:
      state = {
        ...state,
        topbarTheme: action.payload,
      };
      break;
    case type.SHOW_RIGHT_SIDEBAR:
      state = {
        ...state,
        showRightSidebar: action.payload,
      };
      break;
    case type.SHOW_SIDEBAR:
      state = {
        ...state,
        showSidebar: action.payload,
      };
      break;
    case type.TOGGLE_LEFT_MENU:
      state = {
        ...state,
        leftMenu: action.payload,
      };
      break;
    case type.LOADING_REQUEST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case type.LOADING_SUCCESS:
      state = {
        ...state,
        loading: false,
      };
      break;
    case type.SET_LARGE_LOGO_IMAGE:
      state = {
        ...state,
        logoImage: action.payload,
      };
      break;
    default:
      break;
  }
  return state;
};

export default globalReducers;
